exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[dir] .knowledge-base-jumbotron-content{background-image:url(/images/pages/help-center.jpg);background-size:cover}", ""]);

// exports
